import { makeStyles } from '@mui/styles';

const useStyles = makeStyles((theme) => {
    return {
        dataTitle: {
            '&.MuiTypography-root': {
                fontSize: '1.2rem',
                fontWeight: 700,
                color: theme.palette.grey.header,
            },
        },
        dataContainer: {
            '& > .MuiTypography-root': {
                fontSize: '16px',
            },
            backgroundColor: '#eee',
            borderRadius: '8px',
            padding: theme.spacing(2),
            height: '1.25rem',
        },
        appDataStack: {
            display: 'flex',
            flexDirection: 'row',
            [theme.breakpoints.down('lg')]: {
                flexDirection: 'column',
            },
            marginTop: theme.spacing(3),
            gap: theme.spacing(4),
        },
    };
});

export default useStyles;
